import { render, staticRenderFns } from "./GiftsList.vue?vue&type=template&id=664cd9f0&"
import script from "./GiftsList.vue?vue&type=script&lang=ts&"
export * from "./GiftsList.vue?vue&type=script&lang=ts&"
import style0 from "./GiftsList.vue?vue&type=style&index=0&id=664cd9f0&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports